export default "__VITE_ASSET__D12JDS7X__"